import './body-shape.scss';
import useStateStore from 'services/store';

const bodyShapes = [
  {
    id: 'rectangle',
    name: 'Rectangle',
    image: 'images/infor/body-rectangle.webp',
    description: 'My chest is roughly the same as my waist',
  },
  {
    id: 'triangle',
    name: 'Triangle',
    image: 'images/infor/body-triangle.webp',
    description: 'My waist is wider than my chest',
  },
  {
    id: 'inverted-triangle',
    name: 'Inverted Triangle',
    image: 'images/infor/body-inverted-triangle.webp',
    description: 'My chest is wider than my waist',
  },
];

const BodyShape = () => {
  const { inforStepValues: steps, changeInforStepValues } = useStateStore();
  const handleChangeSteps = (id: string) => {
    changeInforStepValues('body-shape', id);
  };

  return (
    <div className="body-container">
      <div className="infor">
        <div className="title">ALRIGHT, LET'S START WITH YOUR BODY SHAPE!</div>
        <div className="confirm">
          Which of the following options best describe your body shape?
        </div>
      </div>
      <div className="image-options">
        {bodyShapes.map((shape) => (
          <div
            onClick={() => handleChangeSteps(shape.id)}
            key={shape.id}
            className={`img-option ${
              steps['body-shape'] === shape.id ? 'active' : ''
            }`}
          >
            <div className="img-container">
              <img src={shape.image} alt="" />
            </div>
            <div className="text">{shape.description}</div>
          </div>
        ))}
      </div>
      {/* <form className="personal-detail-range">
    <div className="input-container msm-type">
      <div className="radio-container">
        <label htmlFor="cm">Centimeters</label>
        <input checked type="radio" id="cm" name="unit" />
      </div>
      <div className="radio-container">
        <label htmlFor="cm">Inches</label>
        <input type="radio" id="inches" name="unit" />
      </div>
    </div>
    <div className="input-container">
      <div className="label-container">
        <label className="label">Age</label>
        <span className="range-value">35 age</span>
      </div>
      <input type="range" min="0" max="100" step="1" />
    </div>
    <div className="input-container">
      <div className="label-container">
        <label className="label">Height</label>
        <span className="range-value">161 cm</span>
      </div>
      <input type="range" min="0" max="100" step="1" />
    </div>
    <div className="input-container">
      <div className="label-container">
        <label className="label">Weight</label>
        <span className="range-value">50 kg</span>
      </div>
      <input type="range" min="0" max="100" step="1" />
    </div>
    <div className="input-container">
      <div className="label-container">
        <label className="label">Shoe size</label>
        <span className="range-value">US 10</span>
      </div>
      <input type="range" min="0" max="100" step="1" />
    </div>
  </form> */}
    </div>
  );
};

export default BodyShape;
